import styled from 'styled-components';
import { flexbox, flexDirection } from '../../styles/helpers/flexbox';

export const CourseNameWrapper = styled.div`
  ${flexbox()};
  ${flexDirection('column')}
`;

export const CourseNameLabel = styled.div`
  font-size: 11px;
`;

export const CourseNameTitle = styled.div`
  font-weight: 600;
  font-size: 14px;
`;



// WEBPACK FOOTER //
// ./components/course-name/styled.js